import { Permissions } from "./permissions";

// Personengebundene Medien: eigene Rechte, unabhängig von der Gerätekonfiguration.
// Benutzer-Medien erfordern weiterhin users.read/users.write.
export const accessMediaReadPermissions = [Permissions.AccessMediaRead, Permissions.AccessMediaWrite];
export const accessMediaWritePermissions = [Permissions.AccessMediaWrite];
